// workaround for circular dependencies
export const FETCH_ARTICLES = 'FETCH_ARTICLES';
export const FETCH_ARTICLE_CONTENT = 'FETCH_ARTICLE_CONTENT';
